import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sd-wishlist-content-empty',
  templateUrl: './wishlist-content-empty.component.html',
  styleUrls: ['./wishlist-content-empty.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WishlistContentEmptyComponent {}
